"use strict";
'use client';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieConsentBar = void 0;
var react_1 = require("react");
var AnalyticsProvider_1 = require("../../AnalyticsProvider");
var hooks_1 = require("../../hooks");
function CookieConsentBar(_a) {
    var children = _a.children;
    var _b = __read((0, react_1.useState)(false), 2), mounted = _b[0], setMounted = _b[1];
    var _c = (0, AnalyticsProvider_1.useAnalyticsContext)(), isEnabled = _c.isEnabled, newsroom = _c.newsroom;
    var _d = (0, hooks_1.useCookieConsent)(), onAccept = _d.accept, onReject = _d.reject, isTrackingCookieAllowed = _d.isTrackingCookieAllowed, isNavigatorSupportsCookies = _d.isNavigatorSupportsCookies;
    (0, react_1.useEffect)(function () { return setMounted(true); }, []);
    if (!mounted ||
        !isEnabled ||
        !isNavigatorSupportsCookies ||
        isTrackingCookieAllowed !== null ||
        (newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent.is_enabled)) {
        return null;
    }
    return children({ onAccept: onAccept, onReject: onReject });
}
exports.CookieConsentBar = CookieConsentBar;
//# sourceMappingURL=CookieConsentBar.js.map